import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Card, CardContent, Stack, Typography } from '@mui/material';
import { useState, useEffect } from 'react';

import { GET_DJT_POSTS } from '../utils/services';

const StyledVideo = styled('video')({
    marginTop: '10px',
    width: '100%',
    height: 'auto',
    objectFit: 'cover',
    aspectRatio: '16/9',
    borderRadius: '8px',
}); 

export default function BlogPage() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        fetch(GET_DJT_POSTS)
            .then(res => res.text())
            .then(
              (result) => {
                if (result !== undefined) {
                    // Wrap in brackets and add commas between each line
                    const jsonArrayText = `[${result.trim().split('\n').join(',')}]`;
                    // Parse it into a JS array
                    const posts = JSON.parse(jsonArrayText);
                    setPosts(cleanPosts(posts));
                    // Now you can work with the data as an array
                    console.log(posts);
                }
              },
              (error) => {
                console.error(error);
              }
            );
    
    }, []);

    const cleanPosts = (posts) => posts.filter((post) => post.content !== null);
    

    const formatIsoDate = (isoString) =>  
        new Intl.DateTimeFormat("en-US", {
            dateStyle: "medium",
            timeStyle: "short",
        }).format(new Date(isoString));


    return (
          <>
            <Helmet>
              <title> Donald J Trump Truth Posts </title>
            </Helmet>
      
            <Container sx={{ paddingBottom: '20px', fontFamily: 'Roboto, sans-serif' }}>
      
              <Stack 
                direction="column" 
                alignItems="center" 
                justifyContent="center" 
                spacing={1} 
                m={3}
                >
                    {
                    posts.map((post) => (
                        <Card key={post.id} sx={{ minWidth: 600, maxWidth: 600}}>
                            <CardContent>
                                <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
                                    {formatIsoDate(post.created_at)}
                                </Typography>

                                <Typography
                                    variant="body2"
                                    dangerouslySetInnerHTML={{ __html: post.content }}
                                />

                                {post.media_attachments.map((media) => (
                                    media.type === 'image' ? 
                                    (
                                        <img 
                                            key={media.id} 
                                            src={media.url} 
                                            alt={media.description} 
                                            style={{ marginTop: '10px', width: '100%', height: 'auto', objectFit: 'cover', borderRadius: '8px' }} 
                                        />
                                    ) : (
                                        <StyledVideo 
                                            key={media.id} 
                                            controls
                                        >
                                            <source src={media.url} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </StyledVideo>
                                    )
                                ))}
                                

                            </CardContent>
                        </Card>
                    ))}

              </Stack>
      
      
            </Container>
          </>
        );
}